import { useState } from 'react';

const SlugifyUrlGenerator = () => {
  const [inputValue, setInputValue] = useState('');
  const [slug, setSlug] = useState('');
  const [isCopied, setIsCopied] = useState(false);
  const [separator, setSeparator] = useState('-'); // Default separator
  const [removeNumbers, setRemoveNumbers] = useState(false);
  const [removeSpecial, setRemoveSpecial] = useState(false);
  const [removeStopWords, setRemoveStopWords] = useState(false);

  const stopWords = ['a', 'an', 'the', 'and', 'or', 'but', 'of', 'on', 'in', 'with', 'to'];

  const handleInputChange = (e) => {
    let value = e.target.value.toLowerCase();

    // Remove numbers if the option is enabled
    if (removeNumbers) {
      value = value.replace(/[0-9]/g, '');
    }

    // Remove special characters if the option is enabled
    if (removeSpecial) {
      value = value.replace(/[^a-zA-Z0-9 ]/g, '');
    }

    // Remove stop words if the option is enabled
    if (removeStopWords) {
      value = value
        .split(' ')
        .filter((word) => !stopWords.includes(word))
        .join(' ');
    }

    // Replace spaces with the selected separator
    const slugifiedValue = value.replace(/ /g, separator);
    setInputValue(e.target.value);
    setSlug(slugifiedValue);
  };

  const handleCopyClick = () => {
    navigator.clipboard.writeText(slug);
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  const handleClear = () => {
    setInputValue('');
    setSlug('');
    setIsCopied('');
    setSeparator('');
    setRemoveSpecial('');
    setRemoveNumbers('');
    setRemoveStopWords('');
  };


  return (
    <div className="container mt-5 p-4 bg-white rounded shadow">
        <div className="card-body">

          <input
            type="text"
            value={inputValue}
            onChange={handleInputChange}
            placeholder="Enter text to slugify"
            className="form-control mb-4"
          />

          <div className="mb-3">
            <label className="form-label">Separator:</label>
            <select
              className="form-select"
              value={separator}
              onChange={(e) => setSeparator(e.target.value)}
            >
              <option value="-">Hyphen (-)</option>
              <option value="_">Underscore (_)</option>
            </select>
          </div>

          <div className="form-check mb-2">
            <input
              type="checkbox"
              className="form-check-input"
              checked={removeNumbers}
              onChange={() => setRemoveNumbers(!removeNumbers)}
            />
            <label className="form-check-label">Remove Numbers</label>
          </div>

          <div className="form-check mb-2">
            <input
              type="checkbox"
              className="form-check-input"
              checked={removeSpecial}
              onChange={() => setRemoveSpecial(!removeSpecial)}
            />
            <label className="form-check-label">Remove Special Characters</label>
          </div>

          <div className="form-check mb-3">
            <input
              type="checkbox"
              className="form-check-input"
              checked={removeStopWords}
              onChange={() => setRemoveStopWords(!removeStopWords)}
            />
            <label className="form-check-label">Remove Stop Words</label>
          </div>

          <div className="d-flex  align-items-center">
            <span className="text-muted">Slug:</span>
            <div className="d-flex align-items-center">
              <span className="me-2">{slug}</span>
       
            </div>
            
          </div>
          <button
                onClick={handleCopyClick}
                className={`btn ${isCopied ? 'btn-success' : 'btn-primary'}`}
              >
                {isCopied ? 'Copied!' : 'Copy'}
              </button>
              <button
        className="btn btn-danger"
        onClick={handleClear}
      >
     Clear
      </button>
        </div>
     
    </div>
  );
};

export default SlugifyUrlGenerator;
